/* istanbul ignore file */
import { BaseFieldLayoutType } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { Typography } from '@mui/material';

const OpportunityPipelineFieldLayout: BaseFieldLayoutType = ({ label, value }) => {
  return (
    <>
      <Typography component="span" color="textSecondary">
        {label as string}
      </Typography>
      {value || <span>{EMPTY_VALUE_INDICATOR}</span>}
    </>
  );
};

export default OpportunityPipelineFieldLayout;
